import { Box, Button, TextField, Typography } from "@mui/material";
import { useMutation, useQueryClient } from "react-query";
import { toast } from "react-toastify";
import { useState } from "react";
import AxiosT from "../../../../setup/setup-axios-bearer";
import LoadingSpinner from "../../../global/loading-spinner";

const ConfilictCreate = ({ id, closeModal }) => {
  const [confilictCount, setconfilictCount] = useState();
  const [confilictDesc, setconfilictDesc] = useState();
  const queryClient = useQueryClient();

  const { data, isLoading, mutate } = useMutation(
    ({ conflict_count, conflict_desc }) =>
      AxiosT.post(`/conflict-create/${id}`, {
        conflict_count,
        conflict_desc,
      }),
    {
      onSuccess: (data) => {
        toast.success("اعلام مغایرت با موفقیت ثبت شد");
        closeModal(false);
        queryClient.resetQueries(["getBuyFactordetail"]);
      },
    }
  );

  const handleSubmit = () => {
    if (!confilictCount) {
      toast.info("لطفا تعداد کالا را وارد نمایید");
    } else if (!confilictDesc) {
      toast.info("لطفا توضیحات تکمیلی را وارد نمایید");
    } else {
      mutate({
        conflict_count: confilictCount,
        conflict_desc: confilictDesc,
      });
    }
  };
  return (
    <>
      {isLoading ? (
        <LoadingSpinner />
      ) : (
        <Box textAlign="center">
          <TextField
            value={confilictCount}
            onChange={(e) => setconfilictCount(e.target.value)}
            label="تعداد کالا"
            fullWidth
            margin="normal"
            name={confilictCount}
          />
          <TextField
            value={confilictDesc}
            onChange={(e) => setconfilictDesc(e.target.value)}
            label="توضیحات"
            fullWidth
            margin="normal"
            name={confilictDesc}
          />
          <Box mt={2}>
            <Button
              type="submit"
              variant="contained"
              onClick={handleSubmit}
              disabled={isLoading}
              style={{ minWidth: "110px" }}
            >
              مغایرت
            </Button>
          </Box>
        </Box>
      )}
    </>
  );
};
export default ConfilictCreate;
